<template>
  <section class="page-container">
    <h1>Policy Needs Attention</h1>
    <policy-list :isFulfilled="true"></policy-list>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import policyList from '@/views/records/policy/components/policyList'
// import { getPolicyDocumentList } from '@/api/policy'
export default {
  name: 'Quotes',
  components:{
    policyList
  },
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // todo
      statusOptions: [
        {
          name: 'In Force',
          id: 1
        },
        {
          name: 'Expired',
          id: 2
        },
        {
          name: 'Cancelled',
          id: 3
        }
      ],
      date: '',
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: []
    }
  },
  watch: {
    // property: {
    //   immediate: true,
    //   handler() {
    //     this.network().getPolicyDocumentList()
    //   }
    // }
  },
  methods: {
    // rowClick({ id, product_id }) {
    //   this.$router.push({
    //     path: product_id > 50? '/records/policy/manual/detail': '/records/policy/detail',
    //     query: {
    //       id,
    //       product_id
    //     }
    //   })
    // },
    // handlerSelectAll(target) {
    //   let origin = ''
    //   switch(target) {
    //     case 'product_id':
    //       origin = 'productTypeOptions'
    //       break
    //     case 'stts':
    //       origin = 'statusOptions'
    //       break
    //     case 'company_id':
    //       origin = 'insurerOptions'
    //       break
    //   }
    //   const data = this[origin].reduce((result, item) => {
    //     result.push(item.id)
    //     return result
    //   }, [])
    //   this[target] = data
    //   this.filterData()
    // },
    // filterData() {
    //   this.pageConfig.currentPage = 1
    //   this.network().getPolicyDocumentList()
    // },
    // currentChange(page) {
    //   this.pageConfig.currentPage = page
    //   this.network().getPolicyDocumentList()
    // },
    // network() {
    //   return {
    //     getPolicyDocumentList: async () => {
    //       const { data } = await getPolicyDocumentList({
    //         pcy_cmnt_dt: this.date[0],
    //         pcy_expry_dt: this.date[1],
    //         product_id: this.product_id,
    //         company_id: this.company_id,
    //         stts: this.stts,
    //         search: this.search,
    //         page: this.pageConfig.currentPage
    //       })
    //       this.tableData = data.data
    //       this.pageConfig.total = data.total
    //     }
    //   }
    // }
  }
}
</script>

<!--<style lang="scss" scoped>-->
<!--.page-container {-->
<!--  position: relative;-->
<!--  color: #303133;-->
<!--  .btn-top-container {-->
<!--    position: absolute;-->
<!--    top: 10px;-->
<!--    right: 0;-->
<!--  }-->
<!--  h1 {-->
<!--    // margin-bottom: 20px;-->
<!--    font-size: 34px;-->
<!--  }-->
<!-- .filter-container {-->
<!--    .filter-box {-->
<!--      margin-bottom: 10px;-->
<!--      .label {-->
<!--        display: block;-->
<!--        padding-bottom: 5px;-->
<!--        font-size: 14px;-->
<!--        font-weight: bold;-->
<!--        .all {-->
<!--          display: inline-block;-->
<!--          padding-left: 15px;-->
<!--          color: #409eff;-->
<!--          font-weight: 500;-->
<!--          cursor: pointer;-->
<!--        }-->
<!--      }-->
<!--      .search-box {-->
<!--          margin-right: 20px;-->
<!--        width: 400px;-->
<!--      }-->
<!--      .quote-box {-->
<!--        width: 300px;-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</style>-->